import {QrScanner} from './components/QrScanner';

export class ValidationScanner {
    private element: JQuery;
    private scannerArea: JQuery;
    private scanner: QrScanner;
    private url: string;
    private initRetriesCount: number = 0;

    constructor() {
        this.element = $('.validation-scanner');
        this.scannerArea = this.element.find('.validation-scanner__scanner');
        this.url = this.element.data('url');

        if (this.scannerArea.length > 0) {
            this.initScanner();
        }
    }

    private initScanner(): void {
        try {
            this.scanner = new QrScanner(this.scannerArea.attr('id'), this.onScanSuccess.bind(this), this.onScanError.bind(this));
        } catch {
            if (this.initRetriesCount < 5) {
                this.initRetriesCount++;
                this.initScanner();
            }
        }
    }

    private onScanSuccess(decodedText: string): void {
        this.scanner.getScanner().stop();
        window.location.href = this.url + '?ticket_number=' + decodedText;
    }

    private onScanError(error: string): void {
        // do nothing
    }
}
